<script lang="ts" setup>
  import type { PropType } from 'vue';
  import type { Breadcrumb, Section, Module } from '@storefront/types';

  defineProps({
    breadcrumbs: { type: Array as PropType<Breadcrumb[]>, required: true },
    sections: { type: Array as PropType<Section[]>, required: true },
    module: { type: Object as PropType<Module>, required: true },
  });
</script>
<template>
  <main id="main" class="container">
    <SfBreadcrumbs :breadcrumbs="breadcrumbs" />
    <h1 class="terms-condition-heading" v-html="module.title" />
    <p class="terms-condition-description" v-html="module.descriptionShort" />
    <SectionRenderer :sections="sections" />
  </main>

  <RouterView />
</template>
<style lang="scss" scoped>
  .terms-condition-description {
    margin: 1rem 0 2rem;
  }

  @media(max-width: 992px) {
    .terms-condition-heading,
    .terms-condition-description {
      padding: 0 0.625rem;
    }
  }
</style>
